import { Heart, Star, Sparkles, Gift } from 'lucide-react';

// Relationship icons and colors - shared configuration
export const relationshipConfig = {
  'Partner': { icon: Heart, color: '#8B5A5A', bgPattern: 'hearts' },      // dusty rose
  'Friend': { icon: Star, color: '#5A6B8B', bgPattern: 'stars' },         // slate blue
  'Family': { icon: Heart, color: '#5A7B5A', bgPattern: 'leaves' },       // forest green
  'Parent': { icon: Heart, color: '#8B7355', bgPattern: 'warm' },         // warm brown
  'Child': { icon: Sparkles, color: '#6B5A8B', bgPattern: 'sparkles' },   // muted purple
  'Sibling': { icon: Star, color: '#5A8B7B', bgPattern: 'dots' },         // teal
  'Colleague': { icon: Gift, color: '#8B8355', bgPattern: 'lines' },      // olive
};

export const colorOptions = [
  '#8B5A5A', // dusty rose
  '#5A6B8B', // slate blue
  '#5A7B5A', // forest green
  '#8B7355', // warm brown
  '#6B5A8B', // muted purple
  '#5A8B7B', // teal
  '#8B8355', // olive
  '#8B5A6B', // mauve
  '#557B8B', // steel blue
  '#7B5A5A', // burgundy
  '#5A8B5A', // sage
  '#6B6B8B'  // lavender gray
];

export const wishlistColors = [
  { name: 'Gold', value: '#FED7A5' },
  { name: 'Pink', value: '#E8B4B8' },
  { name: 'Blue', value: '#A4C8E1' },
  { name: 'Green', value: '#A8D5BA' },
  { name: 'Purple', value: '#D4B5E8' },
  { name: 'Red', value: '#E8A5A5' },
  { name: 'Orange', value: '#F5C094' },
  { name: 'Teal', value: '#9DD6D9' }
];

export const occasionOptions = [
  'Birthday',
  'Anniversary',
  'Wedding',
  'Graduation',
  'Baby Shower',
  'Housewarming',
  'Retirement',
  'Holiday',
  "Valentine's Day",
  "Mother's Day",
  "Father's Day",
  'Christmas',
  'Just Because'
];

export const interestOptions = [
  'Art', 'Music', 'Cooking', 'Reading', 'Technology', 
  'Wellness', 'Outdoors', 'Fashion', 'Gaming', 'Travel', 
  'Plants', 'Coffee/Tea', 'Fitness', 'Pets'
];

export const genderOptions = [
  { value: 'male', label: 'Him' },
  { value: 'female', label: 'Her' },
  { value: '', label: 'Anyone' },
];
